import { render, staticRenderFns } from "./SFormPaymentComp.vue?vue&type=template&id=1b875afe&"
import script from "./SFormPaymentComp.vue?vue&type=script&lang=js&"
export * from "./SFormPaymentComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports